import _map from 'lodash/map';
import _get from 'lodash/get';

import initialState from './initialState';
import actionType from './actionTypes';

const groupsConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_ALL_GROUP_SETUPS_SUCCESS: {
            return {
                ...state,
                groupSetups: action.payload,
                gridGroupSetupConfiguration: {
                    fielddata: initialState.gridGroupSetupConfiguration.fielddata,
                    instances: action.payload,
                },
                groupNames: _map(action.payload, 'group_name'),
            };
        }

        case actionType.GET_GROUP_FIELD_CONFIGURATIONS_SUCCESS:
            const { mappedDataDictionaries, unMappedDataDictionaries } = action.payload;
            return {
                ...state,
                mappedDataDictionaries,
                unMappedDataDictionaries,
                linkedMappedDataDictionaries: [],
            };

        case actionType.GET_GROUP_DD_CONFIGS:
            const payload = action.payload;
            return {
                ...state,
                groupDDConfigs: payload.mappedDataDictionaries,
            };

        case actionType.RESET_MAPPED_DATA_DICTIONARY:
            const resetPayload = action.payload;
            return {
                ...state,
                resetMappedDD: resetPayload,
            };

        case actionType.GET_GROUP_FIELD_LINK_CONFIGURATIONS_SUCCESS: {
            const { mappedDataDictionaries } = action.payload;
            return {
                ...state,
                linkedMappedDataDictionaries: mappedDataDictionaries,
            };
        }

        case actionType.GET_ALL_GROUP_SOURCE_FIELD_MAPPING_SUCCESS:
            return {
                ...state,
                groupFieldSourceMappings: action.payload,
            };

        case actionType.SELECTED_SOURCE_NAMES_CONFIG:
            return {
                ...state,
                selectedSourceNames: _get(action.payload, 'selected_sources', []),
            };
        case actionType.GET_GC_RULE_NAMES:
            return {
                ...state,
                gcRuleNames: action.payload,
            };
        case actionType.SET_ACTIVE_GROUP_INDEX:
            return {
                ...state,
                linkGroupIndex: action.payload,
            };
        case actionType.GET_GROUP_SETTINGS:
            return {
                ...state,
                groupSettings: action.payload,
            };
        default:
            return state;
    }
};

export default groupsConfigurationReducer;
